import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AdminLayout from "../../layouts/AdminLayout";
import api, { API_BASE_URL, fetchData } from "../../api/api";
import Spinner from "../../components/common/Spinner";
import { AuthContext } from "../../context/AuthContext";
import { encryptData } from "../../utils/encryptDecrypt";
import { toast } from "react-toastify";
import { CONSTANT_REDIRECT_TIME } from "../../constant/common";
import MasterAdminLayout from "../../layouts/MasterAdminLayout";
import { formatDateForView } from "../../utils/formateDate";
import { getInitials, getPracticeMapUrl } from "../../utils/helper";
import Select from "react-select";

const MasterAdminActiveListing = () => {
  const navigate = useNavigate();

  const didFetch = useRef(false);
  const [isLoading, setIsLoading] = useState(false);

  const [practicesList, setPracticesList] = useState([]);

  const [selectedPractices, setSelectedPractices] = useState(null);

  const [postCodesList, setPostCodesList] = useState([]);

  const [selectedPostCode, setSelectedPostCode] = useState(null);

  const getPostCodes = async () => {
    try {
      const data = await fetchData("/get-postcodes", {
        status: 1,
      });
      setPostCodesList(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
    }
  };

  const [openIndex, setOpenIndex] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);

  const toggleRow = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const getPractices = async (fk_postcodes_id=null) => {
    setIsLoading(true);
    
    const payload = { status: 1 };
    if (fk_postcodes_id !== null) {
      payload.fk_postcodes_id = fk_postcodes_id;
    }

    try {
      const data = await fetchData("/get-practices", payload);
      setPracticesList(data);
      setCurrentPage(1);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!didFetch.current) {
      getPractices();
      getPostCodes();
      didFetch.current = true;
    }
  }, []);

  if (isLoading) {
    return <Spinner masterAdminLayout={true} />;
  }

  const itemsPerPage = 10;

  const totalPages = Math.ceil(practicesList.length / itemsPerPage);

  const paginatedData =
    practicesList?.length > 0
      ? practicesList.slice(
          (currentPage - 1) * itemsPerPage,
          currentPage * itemsPerPage
        )
      : [];

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
      setOpenIndex(null);
    } 
  };

  return (
    <>
      <MasterAdminLayout>
        <main>
          <div className="px-4 py-4 sm:px-8 sm:py-6 md:px-12 md:py-7 flex md:justify-between gap-3 md:items-center flex-col md:flex-row">
            <h1 className="font-semibold text-lg sm:text-2xl">
              Active Listing
            </h1>
            <div className="flex w-fit items-center gap-3">
              <div className="w-[250px]">
                <Select
                  options={
                    Array.isArray(postCodesList) &&
                    postCodesList.map((item) => ({
                      value: item.postcodes_id,
                      label: item.postcode,
                    }))
                  }
                  placeholder="Search Postcode"
                  className=" text-black custom-select no-icon"
                  onChange={(selectedOption) =>
                    setSelectedPostCode(selectedOption)
                  }
                  value={selectedPostCode}
                />
              </div>
              <div className="">
                <button
                onClick={(e) => getPractices(selectedPostCode?.value)}
                className="py-3 px-4 sm:px-8 border-green  border-2 border-solid bg-green text-white rounded-[8px] font-medium sm:font-semibold text-sm sm:text-base leading-none text-center text-nowrap">
                  Filter
                </button>
              </div>
              <div className="">
                <button 
                onClick={(e) => 
                  {
                    setSelectedPostCode(null)
                    getPractices()
                  }}
                className="py-3 px-4 sm:px-8 border-gray-400  border-2 border-solid bg-gray-400 text-white rounded-[8px] font-medium sm:font-semibold text-sm sm:text-base leading-none text-center text-nowrap">
                  Clear
                </button>
              </div>
            </div>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-lightblue">
                <tr>
                  <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-start w-[54px]"></th>
                  <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-start min-w-[67px] sm:min-w-[90px] w-[90px]">
                    Photo
                  </th>
                  <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-start min-w-48">
                    Practice Name
                  </th>
                  <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-start min-w-48">
                    Category
                  </th>
                  <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-start min-w-48">
                    Address
                  </th>
                  <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-blue font-semibold text-start min-w-[90px] sm:w-[134px]">
                    Listing Plan
                  </th>
                </tr>
              </thead>
              <tbody>
                {paginatedData?.length > 0 ? (
                  paginatedData?.map((practice, index) => (
                    <React.Fragment key={index}>
                      <tr key={index * 2} className="Practice-table-row">
                        <td className="py-2 px-1.5 sm:py-4 sm:px-3 border-t-2 border-solid border-[#dfdfdf]">
                          <button
                            onClick={() => toggleRow(index)}
                            className={`flex items-center justify-center w-full practice-table-btn ${
                              openIndex === index ? "active" : ""
                            }`}
                          >
                            <svg
                              width="30"
                              height="30"
                              viewBox="0 0 30 30"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="dropicon"
                            >
                              <path
                                d="M15.3136 17.744L26.4952 6.5625L29.6899 9.75722L15.3136 24.1335L0.9375 9.75722L4.1322 6.5625L15.3136 17.744Z"
                                fill="#0052CC"
                              />
                            </svg>
                            <svg
                              width="30"
                              height="30"
                              viewBox="0 0 30 30"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="plus"
                            >
                              <path
                                d="M1.66667 0H28.3333C29.2538 0 30 0.7462 30 1.66667V28.3333C30 29.2538 29.2538 30 28.3333 30H1.66667C0.7462 30 0 29.2538 0 28.3333V1.66667C0 0.7462 0.7462 0 1.66667 0ZM13.3333 13.3333H6.66667V16.6667H13.3333V23.3333H16.6667V16.6667H23.3333V13.3333H16.6667V6.66667H13.3333V13.3333Z"
                                fill="#0052CC"
                              />
                            </svg>
                          </button>
                        </td>
                        <td className="py-2 px-1.5 sm:py-4 sm:px-3 border-t-2 border-solid border-[#dfdfdf]">
                          {practice.image ? (
                            <img
                              src={
                                practice.image
                                  ? API_BASE_URL + practice.image
                                  : null
                              }
                              alt=""
                              srcSet=""
                              className="h-[50px] w-[50px] sm:h-[70px] sm:w-[70px] rounded"
                            />
                          ) : (
                            <div className="h-[50px] w-[50px] sm:h-[70px] sm:w-[70px] rounded bg-gray-200 flex items-center justify-center text-lg overflow-hidden font-semibold text-gray-700">
                              {getInitials(practice?.practice_name)}
                            </div>
                          )}
                        </td>
                        <td className="py-2 px-1.5 sm:py-4 sm:px-3 border-t-2 border-solid border-[#dfdfdf]">
                          {practice?.practice_name}
                        </td>
                        <td className="py-2 px-1.5 sm:py-4 sm:px-3 border-t-2 border-solid border-[#dfdfdf]">
                          <span className="text-dark text-base font-medium">
                            {(() => {
                              const serviceNames = practice?.services
                                ?.map((service) => service.name)
                                .join(", ");
                              return serviceNames.length > 50
                                ? serviceNames.slice(0, 50) + "..."
                                : serviceNames;
                            })()}
                          </span>
                        </td>
                        <td className="py-2 px-1.5 sm:py-4 sm:px-3 border-t-2 border-solid border-[#dfdfdf]">
                          {practice?.address && (
                            <Link
                              to={getPracticeMapUrl(practice)}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-dark text-base font-medium underline underline-offset-2"
                            >
                              {practice?.address}, {practice?.suburb?.name}{" "}
                              {practice?.state?.name}{" "}
                              {practice?.postcode?.postcode}
                            </Link>
                          )}
                        </td>
                        <td className="py-2 px-1.5 sm:py-4 sm:px-3 border-t-2 border-solid border-[#dfdfdf]">
                          <span className="text-center text-base font-medium text-dark rounded-full block p-1 bg-[#FBFB87] max-w-[110px] w-full">
                            {practice?.pricing_plan?.name}
                          </span>
                        </td>
                      </tr>
                      <tr
                        key={index * 2 + 1}
                        className={`practitioner-table-row ${
                          openIndex === index ? "" : "hidden"
                        }`}
                      >
                        <td className="px-3"></td>
                        <td className="px-3" colSpan="9">
                          <div>
                            <table className="w-full">
                              <thead className="bg-[#f8f8f8] border-b-2 border-green border-solid">
                                <tr>
                                  <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-dark font-semibold text-start w-[90px]">
                                    Photo
                                  </th>
                                  <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-dark font-semibold text-start ">
                                    Practitioner Name
                                  </th>
                                  <th className="py-2 px-1.5 sm:py-4 sm:px-3 text-base text-dark font-semibold text-start">
                                    Category
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {practice?.practitioners?.length > 0 ? (
                                  <>
                                    {practice?.practitioners?.map(
                                      (practitioner, practitionerIndex) => (
                                        <tr key={practitionerIndex}>
                                          <td className="py-2 px-1.5 sm:py-4 sm:px-3">
                                            {practitioner.image ? (
                                              <img
                                                src={
                                                  practitioner.image
                                                    ? API_BASE_URL +
                                                      practitioner.image
                                                    : null
                                                }
                                                alt=""
                                                srcSet=""
                                                className="h-[50px] w-[50px] sm:h-[70px] sm:w-[70px] rounded"
                                              />
                                            ) : (
                                              <div className="h-[50px] w-[50px] sm:h-[70px] sm:w-[70px] rounded bg-gray-200 flex items-center justify-center text-lg overflow-hidden font-semibold text-gray-700">
                                                {getInitials(
                                                  practitioner?.practice_name
                                                )}
                                              </div>
                                            )}
                                          </td>
                                          <td className="py-2 px-1.5 sm:py-4 sm:px-3">
                                            {practitioner?.practice_name}
                                          </td>
                                          <td className="py-2 px-1.5 sm:py-4 sm:px-3">
                                            <span className="text-dark text-base font-medium">
                                              {(() => {
                                                const serviceNames =
                                                  practitioner?.services
                                                    ?.map(
                                                      (service) => service.name
                                                    )
                                                    .join(", ");
                                                return serviceNames.length > 50
                                                  ? serviceNames.slice(0, 50) +
                                                      "..."
                                                  : serviceNames;
                                              })()}
                                            </span>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </>
                                ) : (
                                  <tr className="Practice-table-row">
                                    <td
                                      colSpan={3}
                                      className="py-2 px-1.5 sm:py-4 sm:px-3 text-center"
                                    >
                                      No Practitioners Found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))
                ) : (
                  <tr className="Practice-table-row">
                    <td
                      colSpan={6}
                      className="text-center py-2 px-1.5 sm:py-4 sm:px-3 border-y-2 border-solid border-[#dfdfdf]"
                    >
                      No Practices Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {paginatedData?.length > 0 && (
            <div className="px-3 py-3 border-t-2 border-solid border-[#dfdfdf]">
              <ul className="flex items-center -space-x-px h-10 text-base justify-end">
                {/* Previous Button */}
                <li>
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className={`flex items-center justify-center px-4 h-10 ms-0 leading-tight border border-e-0 rounded-s-lg border-[#73aeff] 
          ${
            currentPage === 1
              ? "text-gray-400 bg-gray-200 cursor-not-allowed"
              : "text-blue bg-gray-200 hover:bg-gray-100"
          }`}
                  >
                    <svg
                      className="w-3 h-3 rtl:rotate-180"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 6 10"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M5 1 1 5l4 4"
                      ></path>
                    </svg>
                  </button>
                </li>

                {/* Dynamic Pagination Logic */}
                {Array.from({ length: totalPages }, (_, i) => i + 1)
                  .filter((page) => {
                    return (
                      page === 1 ||
                      page === totalPages ||
                      (page >= currentPage - 1 && page <= currentPage + 1)
                    );
                  })
                  .reduce((acc, page, index, arr) => {
                    if (index > 0 && page !== arr[index - 1] + 1) {
                      acc.push("...");
                    }
                    acc.push(page);
                    return acc;
                  }, [])
                  .map((page, index) => (
                    <li key={index}>
                      {page === "..." ? (
                        <span
                          className={`flex items-center justify-center px-4 h-10 leading-tight border border-[#73aeff] bg-gray-200 text-blue`}
                        >
                          ...
                        </span>
                      ) : (
                        <button
                          onClick={() => handlePageChange(page)}
                          className={`flex items-center justify-center px-4 h-10 leading-tight border border-[#73aeff] 
                ${
                  currentPage === page
                    ? "bg-white text-blue"
                    : "bg-gray-200 text-blue hover:bg-gray-100"
                }`}
                        >
                          {page}
                        </button>
                      )}
                    </li>
                  ))}

                {/* Next Button */}
                <li>
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className={`flex items-center justify-center px-4 h-10 leading-tight border rounded-e-lg border-[#73aeff] 
          ${
            currentPage === totalPages
              ? "text-gray-400 bg-gray-200 cursor-not-allowed"
              : "text-blue bg-gray-200 hover:bg-gray-100"
          }`}
                  >
                    <svg
                      className="w-3 h-3 rtl:rotate-180"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 6 10"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="m1 9 4-4-4-4"
                      ></path>
                    </svg>
                  </button>
                </li>
              </ul>
            </div>
          )}
        </main>
      </MasterAdminLayout>
    </>
  );
};

export default MasterAdminActiveListing;
